var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeChatPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    className: "\\u2699    as-di as-r as-s as-t as-aq as-1k as-1l as-4i as-7c \\u26991q16c7l",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F8",
    d: "M0 .098h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.71 18.392a.783.783 0 0 1-.36.081.786.786 0 0 1-.694-.407l-.055-.108-2.192-4.666a.338.338 0 0 1-.027-.163.366.366 0 0 1 .11-.271.384.384 0 0 1 .278-.109.45.45 0 0 1 .25.082l2.58 1.79c.2.12.43.185.665.19.143 0 .284-.028.416-.081l12.096-5.263c-2.193-2.523-5.771-4.15-9.793-4.15C9.354 5.316 4 9.683 4 15.081c0 2.93 1.609 5.589 4.133 7.38a.698.698 0 0 1 .278.869c-.194.732-.527 1.927-.527 1.98a.956.956 0 0 0-.055.298.366.366 0 0 0 .11.27.387.387 0 0 0 .277.109.319.319 0 0 0 .222-.081l2.608-1.493c.192-.116.412-.181.638-.19.122.005.243.023.36.054 1.27.363 2.588.546 3.912.544 6.602 0 11.983-4.368 11.983-9.766a8.44 8.44 0 0 0-1.359-4.53l-13.786 7.812-.084.054Z",
    fill: "#1AAD19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeChatPay);
export default __webpack_public_path__ + "static/media/WE_CHAT_PAY.1d662408b5dad1a30e0cbea50c572037.svg";
export { ForwardRef as ReactComponent };